/* 国际化 ja */
export default {
  lang: {
    desc: '日本語',
  },
  nav: {
    idUpload: 'パスポートのアップロード',
    pay: '決済画面',
    protocol: '清扫协议',
    houseState: '房态',
    report: '清扫布草明细',
  },
  guestID: {
    bgDesc: '<p>旅館業法の規定により、宿泊事業者は宿泊者の本人確認とパスポート情報が一致していることを確認する必要があるため、以下のリンクから宿泊者のパスポートの写真をアップロードするようお願いいたします。こちらの情報は政府関係者以外に提示されません。</p>',
    refImgDesc: '',
    verifyDesc: '※以下のいずれかの方法で本人確認を完了してください【下4文字をご入力ください】',
    contactUs: '聯繫我們',
    loadingOrder: '正在載入訂單資訊，請稍等',
    unknownOrder: '無法解析訂單資訊，請檢查你的連結是否正確！',
    concatWay: '<p><strong>緊急聯繫電話:&nbsp;&nbsp;</strong><br><span>+81 645 605 449<br>+86 18918689798<span></p>' +
          '<p><strong>Wechat ID:&nbsp;&nbsp;</strong><br><span>18918689798<span></p>' +
          '<p><strong>WhatsApp ID:&nbsp;&nbsp;</strong><br><span>+8618918689798<span></p>' +
          '<p><strong>Line ID:&nbsp;&nbsp;</strong><br><span>+8618918689798<span></p>' +
          '<p><strong>Email:&nbsp;&nbsp;</strong><br><a href=\'mailto:acehome_customer@zhusu.onmicrosoft.com?subject=Ask help from guest [Identification]\'>acehome_customer@zhusu.onmicrosoft.com<span></p>',
    verifyOrder: { header: '予約番号', tip: 'の下4文字をご入力ください' },
    verifyPhone: { header: '電話番号', tip: 'の下4文字をご入力ください' },
    verifyEmail: { header: 'メールアドレス', tip: 'の下4文字をご入力ください' },
    verifyStep: ['身份驗證', '上傳證件照', '審核'],
    verifyLast4chars: '下4文字',
    uploadRule: '画像は最大8MBまでの .jpg .png .gif 形式のみアップロード可能です。',
    uploadBut: '点击上传',
    uploadStatus: {
      WAIT: '上传成功',
      PASS: '审核通过',
      REJECTED: '审核不通过（请重新上传符合要求的图片）',
    },
    uploadSuccessMsg: '上传成功！我们期待您的到来~',
    nextStep: '下一步',
    agreementDesc: '<h3>契約内容</h3>' +
      '<p style="margin-bottom: 15px;">本特区民泊建物賃貸借契約書（以下「本契約」という。）は、表記記載の甲と乙との間で、表記記載の契約締結日において、表記記載の対象物件の特区民泊にかかる建物賃貸借に関し、次のとおり契約する。</p>' +
      '<div><p class="title">第1条一時賃貸借の合意</p><p class="content">乙は、対象物件を借地借家法第40条に定める一時使用の目的で甲に貸与し、甲はこれを借り受ける。</p> </div>' +
      '<div><p class="title">第2条使用目的</p><p class="content">甲は、対象物件を、観光、レジャーその他の目的で対象物件所在地に一時滞在するために利用するものとし、対象物件を利用する営業の目的を含むその他の目的のために使用してはならない。</p></div>' +
      '<div><p class="title">第3条賃料</p><p class="content">本契約に基づく賃料は、表記「賃料」欄の合計金額のとおりとし、甲は、●までに、●の方法で支払うものとする。</p></div>' +
      '<div><p class="title">第4条本人確認</p><p class="content">甲は、運営者の求めに応じ、対象物件の利用にあたり、旅券、運転免許証、その他顔写真付きの本人確認書類を提示しなければならない。</p></div>' +
      '<div><p class="title">第5条最低賃貸期間</p><p class="content">甲は、対象物件の最低賃貸期間が3日（2泊3日）であることを確認し、賃貸期間を、最低賃貸期間未満に変更できないことを確認する。3日未満に退去した場合でも、賃料の返金は行わないものとする。 </p></div>' +
      '<div><p class="title">第6条同行者</p><p class="content">1.甲は、運営者に対し、甲に同行して対象物件を利用する者（以下「同行者」という。）は、表記「賃借人に同行して対象物件を利用する者（同行者）」欄に記載している者で全てであることを確約する。 <br>2.甲は、表記「賃借人に同行して対象物件を利用する者（同行者）」欄に記載している者以外の者に、対象物件を使用させてはならない。<br/>甲は、同行者に変更が生じた場合、直ちに運営者に通知をし、運営者の求める事項を報告し、かつ、運営者の求める変更後の同行者の本人確認書類を提示するものとする。<br/>4.甲は、同行者に対し、本契約又は対象物件の利用にあたって甲に課せられる義務を遵守させなければならない。</p></div>' +
      '<div><p class="title">第7条甲における遵守事項</p><p class="sub-title">甲は次の行為をしてはならない</p><p class="content">1.    風俗営業等の規制及び業務の適正化等に関する法律第2条第1項（但し、第5号のうち事前に乙の承諾を得たものを除く。）に定義される風俗営業又は同法律第2条第5項に定義される性風俗関連特殊営業のために対象物件を利用すること。<br/>2.   有害物質、爆発物その他の危険物質を取り扱い、埋蔵、貯蔵、精製、輸送、加工、製造、生成、放出、投棄、移転、又はその他の処分若しくは処理をするために対象物件を利用すること。<br/>3.    暴力的な要求行為、法的な責任を超えた不当な要求行為、取引に関して、脅迫的な言動をし、又は暴力を用いる行為、風説を流布し、偽計を用い又は威力を用いて乙若しくは本物件の所有者である三菱UFJ信託銀行株式会社（以下「本所有者」という。）の信用を毀損し、又は乙若しくは本所有者の業務を妨害する行為を行うこと。</p></div>' +
      // '<div><p class="title">损害赔偿</p><p class="content">除本协议另有规定外，本协议各方仅对因本协议而给另一方造成的损害承担直接损失的普通损害赔偿责任。</p></div>' +
      '<div><p class="title">第8条確認事項</p><p class="sub-title">1.甲は以下の各号に定める事項を確認し、遵守する。</p><p class="content">(1)甲と乙との契約は転貸借であり、転貸借契約上の義務（敷金返還債務（もしあれば）を含む。）は乙のみが負い、本所有者は甲に対して何らの義務も負わないこと。<br/>(2)    甲は、第三者に対して転貸及び賃借権の譲渡を行わないこと。<br/>(3) 甲及び同行者は、住所、氏名などの個人情報を乙が本所有者に開示することを予め承諾すること。<br/></p><p class="sub-title">2.    甲は、乙に対して、甲及び同行者は反社会的勢力（第(1)号に掲げる者をいう。以下同じ。）でないこと及び反社会的勢力との関係又は関与の事実（第(2)号に掲げる場合を含むが、これに限られない。）がないことを誓約する。</p><p class="content">1暴力団、暴力団員又はこれらに準ずる者<br/>2無差別大量殺人行為を行った団体の規制に関する法律に基づき処分を受けている者<br/>3組織的な犯罪の処罰及び犯罪収益の規制等に関する法律に定める犯罪収益等隠匿及び犯罪収益等収受を行い又は行っている疑いのある者<br/>4貸金業法第24条第3項に定義される取立て制限者<br/>5公益に反し社会的に批判を受ける事業を営んでいる者<br/>6市民社会の秩序や安全に脅威を与え健全な経済活動や社会の発展を妨げている者<br/>(2)反社会的勢力との関係又は関与の事実<br/><br/>2暴力団等反社会的勢力が甲の関係者の経営に関与していること<br/>3甲の関係者が暴力団等反社会的勢力に資金提供その他の行為を行うことを通じて暴力団等反社会的勢力の維持又は運営に協力又は関与していること。<br/>4甲の関係者が暴力団等反社会的勢力と交流を持っていること。<br/>5反社会的勢力に自己の名義を利用させて、本契約を締結すること。<br/>6対象物件を反社会的勢力の事務所その他の活動の拠点に供すること</p></div>' +
      '<div><p class="title">第9条運営者による立ち入り</p><p class="content">運営者は、賃貸期間中であっても、対象物件の衛生管理その他の対象物件の管理上特に必要があるときは、あらかじめ甲の承諾を得て、対象物件内に立ち入ることができる。 </p></div><div><p class="title">第10条施設使用時の留意事項、各施設で提供できる役務</p><div class="content">施設の滞在者は使用の際、下記に注意すること<br/>1施設に備え付けられた設備の使用方法<br/>2廃棄物の処理方法<br/>3騒音などにより周囲に迷惑をかけないこと<br/>4火災などの緊急事態が発生した場合の通報先及び初期対応の方法<br/>5対象物件の衛生管理、その他管理上必要があるときは予め滞在者の承諾を得て対象物件内に入れることとする。<br/>別紙(ハウスルール)にて詳細を記載。運営者の説明により甲は確認を行うものとする。<br/></div></div>' +
      '<div><p class="title">第11条解除等</p><p class="content">乙は、甲又は同行者が次の各号に掲げる事由の一つを行った場合、催告を要せず直ちに本契約を将来に向かって解除することができる。 <br/>(1)対象物件において鉄砲、刀剣類又は揮弾性、発火性を有する危険な物品等を製造又は保管した場合<br/>(2)対象物件において大型の金庫その他の重量の大きな物品を持ち込んだ場合<br/>(3)対象物件において排水管を腐食させる恐れのある液体を流した場合<br/>(4)対象物件において大音量でテレビ、ステレオ等を鳴らす操作、ピアノ等を演奏した場合<br/>(5)対象物件において猛獣、毒蛇等の明らかに近隣に迷惑をかける動物を飼育した場合<br/>(6)対象物件を反社会的勢力の事務所その他活動の拠点に供した場合 <br/>(7)対象物件又は対象物件の周辺において、著しく粗野若しくは乱暴な言動を行い、又は威勢を示すことにより市民の住民又は通行人に不安を覚えさせた場合<br/>(8)対象物件に反社会的勢力を居住させ、又は反復継続して反社会的勢力を出入りさせた場合<br/>(9)本契約、又は、運営者が定める対象物件使用にかかるルールに違反した場合<br/></p></div>' +
      '<div><p class="title">第12条損害賠償</p><p class="content">本契約において別段の定めがある場合を除き、本契約の当事者は、本契約に関連して相手方に損害を与えた場合には、直接の結果として現実に被った通常の損害に限り、賠償責任を負うものとする。</p></div>' +
      '<div><p class="title">第13条準拠法及び合意管轄</p><p class="content">本契約の準拠法は日本法とし、本契約に関連して生じた紛争については、大阪地方裁判所を第一審の専属的合意管轄裁判所とする。<br/>以上</p></div>',
    address: '住所',
    name: '氏名',
    phone: 'TEL',
    nationality: '国籍',
    passportNumber: '旅券番号',
    viewExample: 'サンプル表示',
    addGuest: 'ゲスト追加',
    confirm: '送信',
    corporationName: '名称',
    corporationAddress: '住所',
    representativeDirector: '代表取締役',
    invoiceIssuerNumber: '適格請求書発行事業者番号',
    Lessor: '賃貸人（乙）',
    Lessee: '賃借人（甲）',
    expand: '開く',
    collapse: '閉じる',
    specialTitle: '特区民泊建物賃貸借契約書',
    leaseInformation: '賃貸情報',
    propertyName: '物件名',
    leasePeriod: '賃貸期間',
    rent: '賃料',
    leaseExecutionDate: '契約締結日',
    facilityUsagefee: '施設利用料',
    cleaningFee: '清掃料',
    total: '合計',
    photo: 'パスポート写真',
    taxIncluded: '（税込）',
    uploadPassport: '上传护照',
    confirmTip: '必須項目を入力してください',
    notPassport: 'パスポートではない',
    imgNOtClear: '画像が不鮮明である',
  },
  payment: {
    stepOne: '内容確認',
    stepTwo: 'カード情報入力',
    stepThree: 'stripe決済認証',
    stepFour: '完成',
    orderConfirmNo: '予約番号',
    customerInfo: 'ご利用者情報',
    name: '名前',
    email: 'メールアドレス',
    paymentInfo: '支付信息',
    orderPrice: '房费',
    cleanFee: '清扫费',
    deposit: '其他',
    totalAmount: '決済金額',
    status: '状態',
    notPayStatus: '決済待ち',
    successPayStatus: '決済成功',
    failPayStatus: '決済失敗',
    refundPayStatus: 'リファンド',
    payWay: '決済方法',
    payAttention: 'stripeのみはお取り扱いしております',
    receiptEmail: 'メールアドレス',
    receiptEmailContent: 'お客様控えはご入力のメールアドレスに発行されます',
    creditCard: 'クレジットカード',
    depositDesc: 'デポジット支払いの場合はチェックアウト後、問題がない場合は、7営業日以内に返金致します。',
    submitText: '決済へ進む',
    payAgain: '再決済へ進む',
    pay: 'pay',
  },
  upload: {
    clickUploadFile: '点击上传文件',
    uploadDefaultDesc: '最大可以上传10MB的附件，如果文件过大，请压缩后上传',
    uploadSuccess: '上传成功',
    uploadFail: '上传失败',
    uploadFormatWarning: '上传内容格式必须为',
    uploadSizeWarning: '上传内容大小不能超过',
    duplicateWarning: '不能上传重复的文件名',
    cancelUpload: '取消上传',
  },
}
